module.exports = __webpack_public_path__ + "static/media/contact18.8677401a.png";